import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledDialog from 'src/components/app-components/StyledDialog';

type PropsEntity = {
  isOpen: boolean;
  agreeCallback: () => void;
  disagreeCallback: () => void;
};

export const DeleteConfirmModal = ({ isOpen, agreeCallback, disagreeCallback }: PropsEntity) => {
  const { t } = useTranslation();

  return (
    <StyledDialog
      dialogTitle={t('idIssuanceManagement.detail.dialog.delete.title')}
      dialogContent={<Typography sx={{ width: 300 }}>{t('idIssuanceManagement.detail.dialog.delete.content')}</Typography>}
      isOpen={isOpen}
      disagreeCallback={disagreeCallback}
      agreeCallback={agreeCallback}
    />
  );
};
